"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _util = require("@bento-core/util");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * Property Item component generates the result card key:value element
 * e.g. "Program ID: NCT00000000" or "Age: 33"
 *
 * @param {object} props
 * @param {string} props.label - the label of the property
 * @param {string} props.value - the value of the property
 * @param {string} props.link - the relative link of the value (e.g. a local link)
 * @param {string} props.labelLink - the hyperlink of the label (e.g. to an external site)
 * @param {object} props.classes - the classes object used to style the component
 * @param {number} props.index
 * @returns {JSX.Element}
 */
var PropertyItem = function PropertyItem(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var label = props.label,
    value = props.value,
    link = props.link,
    labelLink = props.labelLink,
    classes = props.classes,
    index = props.index;
  var defaultValue = '';
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    className: classes.propertyContainer
  }, value ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.title,
    id: "section_title_".concat(index + 1)
  }, labelLink ? /*#__PURE__*/_react.default.createElement(_util.Anchor, {
    link: labelLink,
    text: label,
    classes: classes
  }) : "".concat(label, ":")), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.content,
    id: "section_description_".concat(index + 1)
  }, value || value === 0 ? link ? /*#__PURE__*/_react.default.createElement(_util.Anchor, {
    link: link,
    text: value,
    classes: classes
  }) : value : defaultValue)) : '');
};
var styles = function styles() {
  return {
    content: {
      color: '#000',
      // fontFamily: theme.custom.fontFamilySans,
      fontFamily: 'Nunito',
      fontSize: '14px',
      whiteSpace: 'normal',
      paddingLeft: '6px',
      letterSpacing: '0.7px'
    },
    title: {
      color: '#000',
      // fontFamily: theme.custom.fontFamilySans,
      fontFamily: 'Inter',
      fontSize: '12px',
      lineHeight: '12px',
      letterSpacing: '0.7px',
      fontWeight: '600',
      whiteSpace: 'nowrap'
    },
    propertyContainer: {
      lineHeight: '17px',
      paddingLeft: '6px'
    },
    link: {
      color: 'black',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      },
      '&:visited': {
        color: '#9F3D26'
      }
    }
  };
};
var _default = (0, _core.withStyles)(styles, {
  withTheme: true
})(PropertyItem);
exports.default = _default;